import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import get, { post } from "../../../../lib/requests";
import { useSelector } from "react-redux";
import Loading from "components/Common/loading";

const useCustomerDetailsStyles = makeStyles(customerDetailsStyles);
const useStyles3 = makeStyles(javascriptStyles);
const useStyles2 = makeStyles(headersStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const AccountUpdateDialog = ({
	accountUpdateDialog,
	setAccountUpdateDialog,
}) => {
	const classesCustomerDetailsStyles = useCustomerDetailsStyles();
	const classesModel = useStyles3();
	const classes2 = useStyles2();
	const classes3 = useStyles3();
	const [loading, setLoading] = useState(false);
	const accountDetails = useSelector((state) => state.account);
	const [tenantDetails, setTenantDetails] = useState({
		Tenant_Name: "",
		Tenant_Description: "",
		First_Name: "",
		Last_Name: "",
		Email_Address: "",
		Address_Line_1: "",
		Address_Line_2: "",
		Address_Line_3: "",
		State: "",
		Suburb: "",
		Postcode: "",
		Phone_Number: "",
	});

	// form validation rules
	const validationSchema = Yup.object().shape({
		Tenant_Name: Yup.string().required("Tenant Name is required"),
		Tenant_Description: Yup.string().required("Tenant Description is required"),
		First_Name: Yup.string().required("First Name is required"),
		Last_Name: Yup.string().required("Last Name is required"),
		Email_Address: Yup.string()
			.required("Email Address is required")
			.email("Email is invalid"),
		Address_Line_1: Yup.string().required("Address Line 1 is required"),
		Address_Line_2: Yup.string(),
		Address_Line_3: Yup.string(),
		State: Yup.string().required("State is required"),
		Suburb: Yup.string().required("Suburb is required"),
		Postcode: Yup.string().required("Postcode is required"),
		Phone_Number: Yup.string().required("Phone Number is required"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	useEffect(() => {
		if (accountDetails) {
			getTenantDetails();
		}
	}, [accountDetails]);

	const getTenantDetails = async () => {
		setLoading(true);
		try {
			await get(`/api/tenant/${accountDetails?.microsoft_id}`, true)
				.then((res) => {
					if (res.data.success) {
						setValue("Tenant_Name", res.data?.records?.tenant.CompanyName);
						setValue(
							"Tenant_Description",
							res.data?.records?.tenant.TenantDescription
						);
						setValue("First_Name", res.data?.records?.tenant.FirstName);
						setValue("Last_Name", res.data?.records?.tenant.LastName);
						setValue("Email_Address", res.data?.records?.tenant.Email);
						setValue("Address_Line_1", res.data?.records?.tenant.Address01);
						setValue("Address_Line_2", res.data?.records?.tenant.Address02);
						setValue("Address_Line_3", res.data?.records?.tenant.Address03);
						setValue("State", res.data?.records?.tenant.State);
						setValue("Suburb", res.data?.records?.tenant.Suburb);
						setValue("Postcode", res.data?.records?.tenant.Postcode);
						setValue("Phone_Number", res.data?.records?.tenant.Phone);
						setTenantDetails({
							Tenant_Name: res.data?.records?.tenant.CompanyName,
							Tenant_Description: res.data?.records?.tenant.TenantDescription,
							First_Name: res.data?.records?.tenant.FirstName,
							Last_Name: res.data?.records?.tenant.LastName,
							Email_Address: res.data?.records?.tenant.Email,
							Address_Line_1: res.data?.records?.tenant.Address01,
							Address_Line_2: res.data?.records?.tenant.Address02,
							Address_Line_3: res.data?.records?.tenant.Address03,
							State: res.data?.records?.tenant.State,
							Suburb: res.data?.records?.tenant.Suburb,
							Postcode: res.data?.records?.tenant.Postcode,
							Phone_Number: res.data?.records?.tenant.Phone,
						});
					} else {
						ErrorMessage("Tenant Details", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Tenant Details", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Tenant Details", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs("Account Update", "processing...");

		try {
			await post(
				`/api/account/update/${accountDetails?.microsoft_id}`,
				formField,
				true
			)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Account Update", res.data.records.message);
						window.scrollTo(0, 0);
						document.body.scrollTop = 0;
						reset();
						setAccountUpdateDialog(false);
					} else {
						ErrorMessage("Account Update", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Account Update", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Account Update", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal + " " + classes3.updateAccountModal,
			}}
			open={accountUpdateDialog}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setAccountUpdateDialog(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(classes3.container, classes3.modalHeader)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setAccountUpdateDialog(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>Account Update</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				<hr />

				{loading && <Loading width={30} height={30} className={classes2.loading} />}

				<form
					onSubmit={handleSubmit(onSubmit)}
					id="accountUpdateForm"
					className={loading ? classesModel.opacity : ""}>
					<GridContainer>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classes2.customInputAdd,
								classesCustomerDetailsStyles.mT20
							)}>
							<div className={classNames(classes2.labelTitleMain)}>
								Tenancy Details
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Tenant Name <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Tenant_Name"),
									value: tenantDetails.Tenant_Name,
									onChange: (e) => {
										console.log(e, "Tenant_Name");
										setTenantDetails({
											...tenantDetails,
											Tenant_Name: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Tenant_Name?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Tenant Description <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Tenant_Description"),
									value: tenantDetails.Tenant_Description,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Tenant_Description: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Tenant_Description?.message}
							</div>
						</GridItem>
						{/* Tenancy Details:
							End User Details:
							End User Address: */}
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classes2.customInputAdd,
								classesCustomerDetailsStyles.mT20
							)}>
							<div className={classNames(classes2.labelTitleMain)}>
								End User Details
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								First Name <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("First_Name"),
									value: tenantDetails.First_Name,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											First_Name: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.First_Name?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Last Name <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Last_Name"),
									value: tenantDetails.Last_Name,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Last_Name: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Last_Name?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Email Address <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Email_Address"),
									value: tenantDetails.Email_Address,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Email_Address: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Email_Address?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Phone Number <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Phone_Number"),
									value: tenantDetails.Phone_Number,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Phone_Number: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Phone_Number?.message}
							</div>
						</GridItem>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classes2.customInputAdd,
								classesCustomerDetailsStyles.mT20
							)}>
							<div className={classNames(classes2.labelTitleMain)}>
								End User Address
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Address Line 1 <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Address_Line_1"),
									value: tenantDetails.Address_Line_1,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Address_Line_1: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Address_Line_1?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Address Line 2
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Address_Line_2"),
									value: tenantDetails.Address_Line_2,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Address_Line_2: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Address_Line_2?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Address Line 3
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Address_Line_3"),
									value: tenantDetails.Address_Line_3,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Address_Line_3: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Address_Line_3?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								State <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("State"),
									value: tenantDetails.State,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											State: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.State?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Suburb <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Suburb"),
									value: tenantDetails.Suburb,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Suburb: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Suburb?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Postcode <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("Postcode"),
									value: tenantDetails.Postcode,
									onChange: (e) => {
										setTenantDetails({
											...tenantDetails,
											Postcode: e.target.value,
										});
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.Postcode?.message}
							</div>
						</GridItem>
					</GridContainer>
				</form>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				{/* <Button
					color="info"
					size="sm"
					form="accountUpdateForm"
					className={classes2.button}
					type="submit"
					disabled={formState.isSubmitting}>
					Save
				</Button> */}
				<button
					form="accountUpdateForm"
					className={classNames(classesCustomerDetailsStyles?.buttonPrimary)}
					type="submit"
					disabled={formState.isSubmitting || loading}>
					Save
				</button>
				<Button
					color="danger"
					size="sm"
					disabled={loading}
					onClick={() => {
						setAccountUpdateDialog(false);
					}}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AccountUpdateDialog;
